import PropTypes from "prop-types";
import { useState } from "react";
import AccordianSection from "./AccordianSection";

const Accordian = ({ allowMultipleOpen, children }) => {
  const initSections = {};
  children.forEach((child) => {
    if (child.props.isOpen) initSections[child.props.label] = true;
    else initSections[child.props.label] = false;
  });

  const [openSections, setOpenSections] = useState(initSections);

  const handleClick = (label) => {
    const isOpen = !!openSections[label];

    if (allowMultipleOpen) {
      setOpenSections((sections) => ({ ...sections, [label]: !isOpen }));
    } else {
      setOpenSections({ [label]: !isOpen });
    }
  };

  return (
    <div>
      {children.map((child) => {
        const { label, isDisplay, children: childrenVal } = child.props;
        return (
          <AccordianSection
            key={label}
            isOpen={!!openSections[label]}
            isDisplay={isDisplay}
            label={label}
            onClick={() => handleClick(label)}
          >
            {childrenVal}
          </AccordianSection>
        );
      })}
    </div>
  );
};

Accordian.propTypes = {
  allowMultipleOpen: PropTypes.bool,
  children: PropTypes.array,
};

Accordian.defaultProps = {
  allowMultipleOpen: false,
};

export default Accordian;
